/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryDownloadResponse } from './RevisdomAPIViewModelsEntryDownloadResponse';
import {
    RevisdomAPIViewModelsEntryDownloadResponseFromJSON,
    RevisdomAPIViewModelsEntryDownloadResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryDownloadResponseToJSON,
    RevisdomAPIViewModelsEntryDownloadResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryDownloadResponse';

/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryDownloadListResponse
 */
export interface RevisdomAPIViewModelsEntryDownloadListResponse {
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsEntryDownloadResponse>}
     * @memberof RevisdomAPIViewModelsEntryDownloadListResponse
     */
    items?: Array<RevisdomAPIViewModelsEntryDownloadResponse> | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryDownloadListResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryDownloadListResponse(value: object): value is RevisdomAPIViewModelsEntryDownloadListResponse {
    return true;
}

export function RevisdomAPIViewModelsEntryDownloadListResponseFromJSON(json: any): RevisdomAPIViewModelsEntryDownloadListResponse {
    return RevisdomAPIViewModelsEntryDownloadListResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryDownloadListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryDownloadListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(RevisdomAPIViewModelsEntryDownloadResponseFromJSON)),
    };
}

export function RevisdomAPIViewModelsEntryDownloadListResponseToJSON(json: any): RevisdomAPIViewModelsEntryDownloadListResponse {
    return RevisdomAPIViewModelsEntryDownloadListResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryDownloadListResponseToJSONTyped(value?: RevisdomAPIViewModelsEntryDownloadListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(RevisdomAPIViewModelsEntryDownloadResponseToJSON)),
    };
}

